export default __webpack_public_path__ + "static/media/contract.1f5816b5.png";